export type LanguageCode = "en" | "es";
export type ThemeMode = "light" | "dark" | "system";
export type AppMode = "simple" | "advanced";
export type BackendLanguageCode = "ENGLISH" | "SPANISH";
export type BackendThemeMode = "LIGHT" | "DARK" | "SYSTEM";

export type UserProfileResponse = {
  id: number;
  email: string;
  is_active: boolean;
  advanced_mode: boolean;
  firstname: string | null;
  lastname: string | null;
  created_at: string;
  updated_at: string;
  phone: string | null;
  theme: BackendThemeMode | null;
  language: BackendLanguageCode | LanguageCode | null;
  deleted_at?: string | null;
};

export type UserProfile = {
  id: string;
  email: string;
  is_active: boolean;
  advanced_mode: boolean;
  firstname: string | null;
  lastname: string | null;
  created_at: string | null;
  updated_at: string | null;
  phone: string | null;
  theme: ThemeMode | null;
  language: LanguageCode | null;
  deleted_at?: string | null;
};

export type UpdateUserPreferencesPayload = {
  language?: BackendLanguageCode;
  theme?: BackendThemeMode;
  advanced_mode?: boolean;
};

export const normalizeLanguage = (value: unknown): LanguageCode =>
  value === "es" || value === "SPANISH"
    ? "es"
    : value === "en" || value === "ENGLISH"
      ? "en"
      : "en";

export const serializeLanguage = (value: LanguageCode): BackendLanguageCode =>
  value === "es" ? "SPANISH" : "ENGLISH";

export const normalizeTheme = (value: unknown): ThemeMode =>
  value === "light" || value === "LIGHT"
    ? "light"
    : value === "dark" || value === "DARK"
      ? "dark"
      : value === "system" || value === "SYSTEM"
        ? "system"
        : "system";

export const normalizeAppMode = (value: unknown): AppMode =>
  value === "advanced" || value === true ? "advanced" : "simple";

export const serializeTheme = (value: ThemeMode): BackendThemeMode =>
  value === "light" ? "LIGHT" : value === "dark" ? "DARK" : "SYSTEM";

export const getLocaleForLanguage = (language: LanguageCode): string =>
  language === "es" ? "es-MX" : "en-US";

export const normalizeUserProfile = (profile: UserProfileResponse | null): UserProfile | null => {
  if (!profile) return null;

  return {
    id: profile.id != null ? String(profile.id) : "",
    email: profile.email ?? "",
    is_active: Boolean(profile.is_active),
    advanced_mode: Boolean(profile.advanced_mode),
    firstname: profile.firstname ?? null,
    lastname: profile.lastname ?? null,
    created_at: profile.created_at ?? null,
    updated_at: profile.updated_at ?? null,
    phone: profile.phone ?? null,
    theme: profile.theme != null ? normalizeTheme(profile.theme) : null,
    language: profile.language != null ? normalizeLanguage(profile.language) : null,
    deleted_at: profile.deleted_at ?? null,
  };
};
